module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre",
    attrs: {
      "id": "pgepubid00008"
    }
  }, [_vm._v("ILLUSTRATIONS.")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('table', {
    staticClass: "calibre7",
    attrs: {
      "border": "0",
      "cellpadding": "14",
      "cellspacing": "0",
      "summary": ""
    }
  }, [_c('tbody', {
    staticClass: "calibre8"
  }, [_c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("the pursuit of the train robber")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('em', {
    staticClass: "calibre19"
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0002"
    }
  }, [_vm._v("Frontispiece")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("page")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("rod blake wins by a length")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0006#imgpg15"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("smiler drives off the tramp")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0011#imgpg55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("in the hands of the enemy")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0016#imgpg97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("rod assists the young man to the “limited”")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0023#imgpg149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("the sheriff hands rod the leather bag")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0034#imgpg221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("202")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("in the railroad wreck")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0036#imgpg235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("214")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("“he launched himself forward”")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0040#imgpg263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("240")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00009",
      "title": "[Pg 1]"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0